"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExcludedPatterns = exports.scan = exports.toRelativePaths = void 0;
const fs = require("fs");
const path = require("path");
const path_1 = require("path");
const debug_1 = require("./debug");
const find_1 = require("./find");
const hosted_git_info_1 = require("hosted-git-info");
const signatures_1 = require("./signatures");
const git_1 = require("./git");
const extract_1 = require("./extract");
const fs_1 = require("./utils/fs");
const common_1 = require("./common");
const dotSnyk = require("./utils/dotsnyk");
const invariants_1 = require("./utils/dotsnyk/invariants");
function toRelativePaths(basedir, signatures, extractionWorkspace) {
    signatures.forEach((s) => {
        const src = extractionWorkspace && s.path.includes(extractionWorkspace)
            ? extractionWorkspace
            : basedir;
        s.path = path.relative(src, s.path);
    });
}
exports.toRelativePaths = toRelativePaths;
async function scan(options) {
    try {
        debug_1.debug.enabled = !!(options === null || options === void 0 ? void 0 : options.debug);
        debug_1.debug('options %o \n', options);
        const extractionDepthLimit = options['max-depth'] || 0;
        if (extractionDepthLimit < 0) {
            throw 'invalid options: --max-depth should be greater than or equal to 0.';
        }
        if (!options.path) {
            throw 'invalid options: no path provided.';
        }
        if (!fs.existsSync(options.path)) {
            throw `'${options.path}' does not exist.`;
        }
        const start = Date.now();
        const projectRoot = options.path;
        const excludedPatterns = getExcludedPatterns(projectRoot, options['policy-path']);
        if (common_1.isWin) {
            excludedPatterns.forEach((path, index) => {
                excludedPatterns[index] = path.split(path_1.posix.sep).join(path_1.sep);
            });
        }
        const [filePaths, archivePaths] = await find_1.find(projectRoot, excludedPatterns);
        if (!filePaths.length) {
            throw 'There were no files in the target directory that could be scanned. Check if the directory is empty or if an ignore policy is active.';
        }
        let extractionWorkspace = undefined;
        if (0 < extractionDepthLimit && 0 < archivePaths.length) {
            const temporaryDir = await fs_1.createTemporaryDir();
            extractionWorkspace = path_1.join(temporaryDir, common_1.DECOMPRESSING_WORKSPACE_DIR);
            await extract_1.extract(archivePaths, temporaryDir, extractionDepthLimit);
            const [newFilePaths, newArchivePaths] = await find_1.find(extractionWorkspace, excludedPatterns);
            filePaths.push(...newFilePaths, ...newArchivePaths);
        }
        else {
            filePaths.push(...archivePaths);
        }
        debug_1.debug('%d files found \n', filePaths.length);
        const signatures = await signatures_1.computeSignaturesConcurrently(filePaths);
        toRelativePaths(projectRoot, signatures, extractionWorkspace);
        const end = Date.now();
        const totalMilliseconds = end - start;
        const totalFileSignatures = signatures.length;
        const totalSecondsElapsedToGenerateFileSignatures = Math.floor(totalMilliseconds / 1000);
        debug_1.debug(`total fileSignatures: ${totalFileSignatures} \n`);
        debug_1.debug(`elapsed time in seconds to generate fileSignatures: ${totalSecondsElapsedToGenerateFileSignatures}s \n`);
        const facts = [{ type: 'fileSignatures', data: signatures }];
        const analytics = [
            {
                name: 'fileSignaturesAnalyticsContext',
                data: {
                    totalFileSignatures,
                    totalSecondsElapsedToGenerateFileSignatures,
                },
            },
        ];
        const target = await git_1.getTarget();
        debug_1.debug('target %o \n', target);
        const gitInfo = hosted_git_info_1.fromUrl(target.remoteUrl);
        const name = options['project-name'] || (gitInfo === null || gitInfo === void 0 ? void 0 : gitInfo.project) || path.basename(projectRoot);
        debug_1.debug('name %o \n', name);
        const targetReference = options['target-reference'];
        if (options['remote-repo-url']) {
            target.remoteUrl = options['remote-repo-url'];
        }
        const scanResults = [
            {
                facts,
                identity: {
                    type: 'cpp',
                },
                name,
                target,
                analytics,
                targetReference,
            },
        ];
        return {
            scanResults,
        };
    }
    catch (error) {
        throw new Error(`Could not scan C/C++ project: ${error}`);
    }
}
exports.scan = scan;
function getExcludedPatterns(projectRoot, policyFilePath = path_1.join(projectRoot, invariants_1.DEFAULT_SNYK_POLICY_FILE)) {
    var _a, _b;
    if (!dotSnyk.exists(policyFilePath)) {
        return [];
    }
    const config = dotSnyk.parse(policyFilePath);
    const paths = (_b = (_a = config === null || config === void 0 ? void 0 : config.exclude) === null || _a === void 0 ? void 0 : _a.global) === null || _b === void 0 ? void 0 : _b.filter((item) => {
        if (typeof item === 'object') {
            const key = Object.keys(item)[0];
            return !key ? false : !dotSnyk.hasExpired(item[key].expires);
        }
        return true;
    }).map((item) => {
        if (typeof item === 'object') {
            return Object.keys(item)[0];
        }
        return item;
    });
    return [policyFilePath, ...dotSnyk.toAbsolutePaths(projectRoot, paths)];
}
exports.getExcludedPatterns = getExcludedPatterns;
//# sourceMappingURL=scan.js.map